<template>
    <span>
        <span v-if="values.isVip">
            <img
              class="guest-status-icon"
              :src="`/static/images/icons/reservation/vip_bg_${size}.svg`"
              title="${reservation.user.status.name}" />         
        </span>
        <span v-else-if="values.isBlocklist">
            <img
              class="guest-status-icon"
              :src="`/static/images/icons/reservation/blocklist_bg_${size}.svg`"
              title="${reservation.user.status.name}" />         
        </span>
        <span v-else></span>
    </span>
</template>

<script>;
import isNil from 'lodash/isNil';

export default {
    props: {
        reservation: Object,
        size: {
            type: String,
            default: '24'
        },                
    },
    mounted() {
        this.values = this.getInitialValues();
    },
    data() {
        return {
            values: this.getInitialValues(),
        }
    },    
    methods: {
        getInitialValues(item) {
            let isVip = false;
            let isBlocklist = false;
            
            if (!isNil(this.reservation.user.status) && this.reservation.user.status.is_vip) {
                isVip = true;
            }

            if (!isNil(this.reservation.user.status) && this.reservation.user.status.is_blocklist) {
                isBlocklist = true;
            }
            
            return {
                'isVip': isVip,
                'isBlocklist': isBlocklist,
            }
        }
    },    
    watch: {
        reservation() {
            this.values = this.getInitialValues();
        }
    }    
};
</script>

<style lang="scss" scoped>


</style>